import { createContext } from 'react';

/**
 * Loading context value interface
 */
export interface LoadingContextValue {
  isLoading: number;
  showLoading: () => void;
  hideLoading: () => void;
}

/**
 * Loading context for managing global loading state
 */
export const LoadingContext = createContext<LoadingContextValue | undefined>(undefined);

LoadingContext.displayName = 'LoadingContext';
